// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"60cec548","726":"6de26efa"}[chunkId] + ".chunk.js";
};